import { Button } from "@/toggle-ui-kit/button";
import { Send } from "lucide-react";
import { useCallback, useRef } from "react";

interface ChatInputProps {
  onSend: (question: string) => void;
  disabled: boolean;
}

export const ChatInput: React.FC<ChatInputProps> = ({ onSend, disabled }) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleSend = useCallback(() => {
    const value = textareaRef.current?.value.trim();
    if (!value) return;
    onSend(value);
    if (textareaRef.current) {
      textareaRef.current.value = "";
    }
  }, [onSend]);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
      // 한글 IME 조합 중 Enter 무시
      if (e.nativeEvent.isComposing || e.keyCode === 229) return;
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        handleSend();
      }
    },
    [handleSend],
  );

  return (
    <div className="flex items-end gap-2 px-3 py-3 border-t border-line-alternative bg-white">
      <textarea
        ref={textareaRef}
        rows={2}
        placeholder="예: 어떤 XBRL 태그를 써야 하나요?"
        className="flex-1 resize-none px-3 py-2.5 border border-line-normal rounded-lg body-2-normal-regular text-label-normal placeholder:text-label-assistive focus:outline-none focus:border-label-normal"
        onKeyDown={handleKeyDown}
        disabled={disabled}
      />
      <Button
        variant="solid"
        color="secondary"
        size={36}
        onClick={handleSend}
        disabled={disabled}
        leftIcon={<Send className="size-4" />}
      >
        전송
      </Button>
    </div>
  );
};
